<template>
  <div class="py-3" :class="last ? '' : 'border-b border-surface-100'">
    <div
      class="flex items-center gap-3"
      :class="disabled ? 'pointer-events-none opacity-60' : 'cursor-pointer'"
      @click="onToggle(!status)"
    >
      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2">
          <span class="text-sm font-medium">{{ title }}</span>
          <span
            v-if="badge"
            class="text-[10px] font-semibold bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full flex-none"
          >{{ badge }}</span>
        </div>
        <div v-if="description" class="text-xs text-surface-500 mt-1 leading-relaxed text-pretty">{{ description }}</div>
      </div>
      <ToggleSwitch
        :modelValue="status"
        class="flex-none"
        :disabled="disabled"
        @update:modelValue="onToggle"
        @click.stop
      />
    </div>
    <!-- Reveal content when on -->
    <div v-if="status && $slots.default" class="mt-2.5">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import ToggleSwitch from 'primevue/toggleswitch';

defineProps<{
  title: string;
  description?: string;
  status: boolean;
  badge?: string;
  last?: boolean;
  disabled?: boolean;
}>();
const emit = defineEmits<{ valueChanged: [value: boolean] }>();

const onToggle = (val: boolean) => emit('valueChanged', val);
</script>
